<script lang="ts">
  import Tags from "./Tags.svelte";
  import ErrorMessage from "./ErrorMessage.svelte";
  import { onMount } from "svelte";

  onMount(() => {
    // TODO: maybe set this from outside
    popup = new URLSearchParams(window.location.search).get("popup") === "true";
    if(pin.url) {
      fetchPin(pin.url);
      fetchURLMetadata(pin.url);
    }
  });

  export let tags: string[] = [];
  export let errors = null;
  export let formUrl: string;
  export let popup = false;

  export let pin: {
    public_id: string;
    title: string;
    url: string;
    comment: string;
    tag_names: string[];
  } = {
    title: "",
    url: "",
    comment: "",
    tag_names: [],
  };

  let existingPin: {
    title: string;
    url: string;
    comment: string;
    tag_names: string[];
  } = {
    title: "",
    url: "",
    comment: "",
    tag_names: [],
  };

  const onChangeUrl = (e: Event) => {
    const target = e.target as HTMLInputElement;
    const url = target.value;
    window.history.pushState({}, "", `?url=${url}`);
    fetchPin(url);
    fetchURLMetadata(url);
  };

  const fetchPin = async (url: string) => {
    const res = await fetch(`/pins/fetch_existing_pin?url=${url}`);
    const data = await res.json();
    if(data.pin !== null) {
      existingPin = data.pin;
      pin.title = existingPin.title;
      pin.comment = existingPin.comment;
      pin.tags = existingPin.tag_names;
    }
  };

  let urlMetadata = {
    title: null,
    description: null,
    tags: []
  };

  const fetchURLMetadata = async (url: string) => {
    const res = await fetch(`/pins/fetch_metadata?url=${url}`);
    const data = await res.json();
    if(Object.keys(data).length > 0) {
      urlMetadata = data;
    }
  };

  const setTitleFromMetadata = (e) => {
    e.preventDefault();
    pin.title = urlMetadata.title;
  };

  const addTag = (e) => {
    e.preventDefault();
    const tag = e.target.dataset.value;
    if(!pin.tags.includes(tag)) {
      pin.tags.push(tag);
      pin = pin
    }
  };

  const removeTag = (e) => {
    e.preventDefault();
    const tag = e.target.dataset.value;
    pin.tags = pin.tags.filter(t => t !== tag);
    pin = pin
  };

  const isPresent = (value) => {
    return value !== null && value !== undefined && value !== "";
  };

  $: showTitleMetadata = isPresent(urlMetadata.title) && urlMetadata.title !== pin.title;
  $: newRecord = !pin.public_id;
  $: formMethod = newRecord ? "post" : "put";
</script>
<form action={formUrl} method="post">
  {#if popup}
    <input type="hidden" name="popup" value="true" />
  {/if}
  <input type="hidden" name="_method" value={formMethod} />
  <div class="form-floating mb-3">
    <input disabled={!newRecord} name="pin[url]" type="url" class="form-control" id="pin_url" bind:value={pin.url} on:change={onChangeUrl}>
    <label for="pin_url">URL</label>
    <ErrorMessage errors={errors} attribute='url'/>
  </div>
  <div class="form-floating mb-3">
    <input name="pin[title]" type="text" class="form-control" id="pin_title" bind:value={pin.title}>
    {#if showTitleMetadata}
      <div class="form-text">
        <a href="#" class="badge bg-primary" on:click={ setTitleFromMetadata }>
          <i class="bi bi-arrow-90deg-up"></i>
        </a>
        {urlMetadata.title}
      </div>
    {/if}
    <label for="pin_title">Title</label>
    <ErrorMessage errors={errors} attribute='title' />
  </div>
  <div class="form-floating mb-3">
    <Tags	className="pt-4 form-control" id="pin_tags" name="pin[tags][]" minChars={1} autoComplete={tags} bind:tags={pin.tags}/>
    <label for="pin_tags">Tags</label>
    <ErrorMessage errors={errors} attribute='tags' />
    {#each urlMetadata.tags as tag}
      {#if !pin.tags.includes(tag)}
        <button class="badge bg-primary" data-value={tag} on:click={ addTag }>{tag}</button>
      {:else}
        <button class="badge bg-secondary" data-value={tag} on:click={ removeTag }>{tag}</button>
      {/if}
    {/each}
  </div>
  <div class="form-floating mb-3">
    <textarea name="pin[comment]" class="form-control" id="pin_comment" bind:value={pin.comment} />
    <label for="pin_comment">Comment</label>
    <ErrorMessage errors={errors} attribute='comment' />
  </div>
  <button type="submit" class="btn btn-primary">Save</button>
</form>

<style>
</style>
